import HorizontalLine from '~/components/HorizontalLine';

import ProductDescription from './ProductDescription';
import ProductInformation from './ProductInformation';

type Props = {
  showEditorialPolicy?: boolean;
};

const ProductDetails = ({ showEditorialPolicy }: Props) => {
  return (
    <>
      <HorizontalLine />
      <div className="py-6 md:py-12">
        <ProductDescription showEditorialPolicy={showEditorialPolicy} />
      </div>
      <HorizontalLine className="hidden lg:block" />
      <div className="hidden py-6 md:py-12 lg:block">
        <ProductInformation />
      </div>
    </>
  );
};

export default ProductDetails;
